import { OrgType } from "./orgType";
import { IProfile } from "@ski/oidc";

export function isUserCustomer(profile: IProfile): boolean {
  return (
    profile !== null &&
    (profile.orgType == OrgType.Kunde || profile.orgType == OrgType.SKI)
  );
}
